// Category description: hides "… Pročitaj više" when the text already fits in the 2-line clamp. CSS can't tell
// whether clamped text overflows, so an empty marker is put right after the last piece of text and an
// IntersectionObserver watches it against the clamped box: marker clipped -> the text overflows. The browser works
// that out during its own rendering, so nothing here reads layout (scrollHeight forced a synchronous layout, even
// inside a ResizeObserver callback), and it reports again by itself when a resize or a web font swap changes the result.
(function () {
	'use strict';

	const TOGGLE = '.shop-archive__description-toggle';

	// The marker has to sit in the text flow: the paragraph that holds the clamped line is cut to the clamp height
	// itself, so its own box (or anything after it) always looks visible.
	const addEndMarker = (text) => {
		const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT, {
			acceptNode: (node) =>
				node.data.trim() && !node.parentElement.closest(TOGGLE) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT,
		});
		let lastText = null;
		while (walker.nextNode()) lastText = walker.currentNode;

		const marker = document.createElement('span');
		marker.setAttribute('aria-hidden', 'true');

		if (lastText) {
			lastText.after(marker);
		} else {
			// No text at all (e.g. only images): the end of the content.
			const toggle = text.querySelector(TOGGLE);
			if (toggle) toggle.before(marker);
			else text.append(marker);
		}

		return marker;
	};

	const update = (entry) => {
		const wrapper = entry.target.closest('.shop-archive__description-wrapper');
		const input = wrapper ? wrapper.querySelector('.shop-archive__description-toggle-input') : null;

		// Expanded: everything is visible, which says nothing about the clamped state.
		if (!input || input.checked) return;

		const isShort = entry.isIntersecting;
		wrapper.classList.toggle('is-short', isShort);
		// Nothing to expand: the (visually hidden) checkbox must not stay a tab stop.
		input.tabIndex = isShort ? -1 : 0;
	};

	const init = () => {
		document.querySelectorAll('.shop-archive__description-wrapper .shop-archive__description-text').forEach((text) => {
			// 1px of tolerance below the box for sub-pixel rounding of the line height.
			new IntersectionObserver((entries) => update(entries[entries.length - 1]), {
				root: text,
				rootMargin: '0px 0px 1px 0px',
				threshold: [0, 1],
			}).observe(addEndMarker(text));
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
